// Traduções da aba Planejamento do Dashboard — coletadas por glob em core/i18n/messages.ts.
export default {
  pt: {
    'dashboard.aba.operacao': 'Operação',
    'dashboard.aba.planejamento': 'Planejamento',
    'dashboard.planejamento.titulo': 'Previsão de colheita',
    'dashboard.planejamento.detalhe': 'A planilha de planejamento do cliente, uma linha por contrato e fazenda, contra a medição do Protheus.',
    'dashboard.planejamento.lidas': 'Medições do Protheus lidas em {{quando}}',
    'dashboard.planejamento.semLeitura': 'Nenhuma leitura de medição do Protheus ainda',
    'dashboard.planejamento.loadError': 'Não foi possível carregar o planejamento',
    'dashboard.planejamento.cliente': 'Cliente',
    'dashboard.planejamento.importar': 'Importar planilha',
    'dashboard.planejamento.importarTitulo': 'Importar a planilha de planejamento',
    'dashboard.planejamento.importarExplica': 'Envie a planilha de planejamento do cliente como ela vem, em .xlsx ou .csv. Ela precisa das colunas Contrato e Semana Colheita, e a linha sem semana entra do mesmo jeito, fora das contas por semana. Hectares, Km, Volume, Operação, Fazenda, Cidade, Estado, Cooperante e UBS entram quando existem, e célula vazia não apaga o que já estava gravado. A data vira a segunda-feira da semana, e a data informada fica guardada. O mesmo contrato em duas fazendas vira duas linhas. O contrato ainda sem cadastro entra do mesmo jeito e se liga sozinho quando for cadastrado.',
    'dashboard.planejamento.arquivo': 'Escolher planilha',
    'dashboard.planejamento.carga.gravadas': 'Novas',
    'dashboard.planejamento.carga.atualizadas': 'Atualizadas',
    'dashboard.planejamento.carga.mantidas': 'Sem mudança',
    'dashboard.planejamento.carga.ignoradas': 'Linhas ignoradas',
    'dashboard.planejamento.carga.pendentes': 'Sem cadastro no HUB',
    'dashboard.planejamento.carga.replanejadas': 'Com semana nova',
    'dashboard.planejamento.carga.primeiraSemana': 'Primeira semana',
    'dashboard.planejamento.carga.ultimaSemana': 'Última semana',
    'dashboard.planejamento.carga.hectares': 'Hectares previstos',
    'dashboard.planejamento.ind.contratos': 'Contratos previstos',
    'dashboard.planejamento.ind.contratosHint': '{{n}} sem cadastro no HUB',
    'dashboard.planejamento.ind.contratosTodos': 'todos cadastrados no HUB',
    'dashboard.planejamento.ind.previsto': 'Hectares previstos',
    'dashboard.planejamento.ind.previstoHint': '{{n}} viagens pela conta abaixo',
    'dashboard.planejamento.ind.medido': 'Hectares medidos',
    'dashboard.planejamento.ind.medidoHint': '{{pct}} do previsto nos contratos já medidos',
    'dashboard.planejamento.ind.medidoNada': 'nenhuma medição ainda',
    'dashboard.planejamento.ind.fora': 'Fora da semana',
    'dashboard.planejamento.ind.foraHint': '{{n}} sem medição com a semana já passada',
    'dashboard.planejamento.ind.pico': 'Pico de caminhões',
    'dashboard.planejamento.ind.picoHint': 'semana de {{semana}}',
    'dashboard.planejamento.ind.picoNada': 'sem viagem prevista',
    'dashboard.planejamento.hectaresTitulo': 'Hectares por semana',
    'dashboard.planejamento.hectaresRodape': 'Só contratos com colheita. Previsto pela semana da planilha do cliente, medido pela data final da medição do Protheus.',
    'dashboard.planejamento.caminhoesTitulo': 'Caminhões por semana',
    'dashboard.planejamento.caminhoesRodape': 'Só contratos com transporte. Previstos: um caminhão a cada {{ha}} hectares. Utilizados: as cargas que rodaram na semana, pela Data HUB.',
    'dashboard.planejamento.serie.previsto': 'Previsto',
    'dashboard.planejamento.serie.medido': 'Medido',
    'dashboard.planejamento.semDados': 'Sem previsão no recorte',
    'dashboard.planejamento.parametros': 'Parâmetros da conta',
    'dashboard.planejamento.parametrosExplica': 'A conta muda na hora e vale só neste navegador.',
    'dashboard.planejamento.param.haPorViagem': 'Hectares por viagem',
    'dashboard.planejamento.param.haPorViagemAjuda': 'O padrão é 3. A média real dos contratos já medidos foi de 3,33 em 27/10/2026.',
    'dashboard.planejamento.param.restaurar': 'Voltar ao padrão',
    'dashboard.planejamento.semKm_one': '{{count}} contrato com transporte sem km no cadastro fica fora do km médio.',
    'dashboard.planejamento.semKm_other': '{{count}} contratos com transporte sem km no cadastro ficam fora do km médio.',
    'dashboard.planejamento.semanas': 'Semana a semana',
    'dashboard.planejamento.col.semana': 'Semana',
    'dashboard.planejamento.col.contratos': 'Contratos',
    'dashboard.planejamento.col.previsto': 'Previsto',
    'dashboard.planejamento.col.medido': 'Medido',
    'dashboard.planejamento.col.viagens': 'Viagens',
    'dashboard.planejamento.col.kmMedio': 'Km médio',
    'dashboard.planejamento.col.contrato': 'Contrato',
    'dashboard.planejamento.col.fazenda': 'Fazenda',
    'dashboard.planejamento.col.semanaPrevista': 'Semana prevista',
    'dashboard.planejamento.col.diferenca': 'Diferença',
    'dashboard.planejamento.col.colheita': 'Data real',
    'dashboard.planejamento.col.km': 'Km',
    'dashboard.planejamento.col.situacao': 'Situação',
    'dashboard.planejamento.semanaAtual': 'Semana atual',
    'dashboard.planejamento.antes': 'Antes {{data}}',
    'dashboard.planejamento.doContrato': 'do contrato',
    'dashboard.planejamento.semCadastro': 'Sem cadastro',
    'dashboard.planejamento.periodo': '{{de}} a {{ate}}',
    'dashboard.planejamento.contratos': 'Contratos previstos',
    'dashboard.planejamento.total_one': '{{count}} contrato',
    'dashboard.planejamento.total_other': '{{count}} contratos',
    'dashboard.planejamento.vazio': 'Nenhuma planilha de planejamento importada ainda. Importe a planilha do cliente para começar.',
    'dashboard.planejamento.vazioLeitura': 'Nenhuma planilha de planejamento importada ainda.',
    'dashboard.planejamento.situacao.no_prazo': 'No prazo',
    'dashboard.planejamento.situacao.adiantada': 'Adiantada',
    'dashboard.planejamento.situacao.atrasada': 'Atrasada',
    'dashboard.planejamento.situacao.sem_medicao': 'Sem medição',
    'dashboard.planejamento.situacao.na_semana': 'Na semana',
    'dashboard.planejamento.situacao.prevista': 'Prevista',
    'dashboard.planejamento.carga.semSemana': 'Sem semana',
    'dashboard.planejamento.ind.semSemana': '{{n}} sem semana',
    'dashboard.planejamento.situacao.so_transporte': 'Só transporte',
    'dashboard.planejamento.situacao.sem_semana': 'Sem semana',
    'dashboard.planejamento.semSemana': 'Sem semana',
    'dashboard.planejamento.informada': 'Informada {{data}}',
    'dashboard.planejamento.col.operacao': 'Operação',
    'dashboard.planejamento.numeroRepetido': 'Em mais de uma fazenda',
    'dashboard.planejamento.numeroRepetidoAjuda': 'O mesmo número vem em mais de uma fazenda na planilha. O contrato do HUB se liga só à linha da fazenda com o nome dele.',
    'dashboard.planejamento.foraDaPlanilha_one': '{{count}} contrato do HUB ainda por colher não está na planilha',
    'dashboard.planejamento.foraDaPlanilha_other': '{{count}} contratos do HUB ainda por colher não estão na planilha',
    'dashboard.planejamento.foraDaPlanilhaVer': 'Ver contratos',
    'dashboard.planejamento.foraDaPlanilhaMais_one': 'e mais {{count}} contrato',
    'dashboard.planejamento.foraDaPlanilhaMais_other': 'e mais {{count}} contratos',
    'dashboard.planejamento.remover': 'Remover previsão',
    'dashboard.planejamento.removerTitulo': 'Remover a previsão do contrato {{numero}}?',
    'dashboard.planejamento.removerMensagem': 'Ela sai da aba e das contas. Para voltar, importe a planilha de novo.',
    'dashboard.planejamento.removerConfirmar': 'Remover',
    'dashboard.planejamento.removida': 'Previsão removida.',
    'dashboard.planejamento.serie.previstos': 'Previstos',
    'dashboard.planejamento.serie.utilizados': 'Utilizados',
    'dashboard.planejamento.col.caminhoesPrevistos': 'Caminhões previstos',
    'dashboard.planejamento.col.caminhoesUtilizados': 'Caminhões utilizados',
    'dashboard.planejamento.pelasViagens': 'pelas viagens',
    'dashboard.planejamento.filtro.clienteHub': 'Cliente HUB',
    'dashboard.planejamento.filtro.clienteProtheus': 'Cliente Protheus',
    'dashboard.planejamento.filtro.dupla': 'Dupla',
    'dashboard.planejamento.filtro.operacao': 'Operação',
    'dashboard.planejamento.filtro.limpar': 'Limpar filtros',
    'dashboard.planejamento.operacao.colheita': 'Colheita',
    'dashboard.planejamento.operacao.transporte': 'Transporte',
    'dashboard.planejamento.operacao.colheita_transporte': 'Colheita e Transporte',
    'dashboard.planejamento.clientes.titulo': 'Hectares por cliente',
    'dashboard.planejamento.clientes.col.cliente': 'Cliente',
    'dashboard.planejamento.clientes.col.lancados': 'Hectares lançados',
    'dashboard.planejamento.clientes.col.colhidos': 'Hectares colhidos',
    'dashboard.planejamento.clientes.col.pct': '%',
    'dashboard.planejamento.clientes.total': 'Total',
    'dashboard.planejamento.clientes.semCliente': 'Sem cliente',
    'dashboard.planejamento.clientes.rodape': 'Lançados são os hectares previstos na planilha, e colhidos os medidos pelo Protheus. Só contratos com colheita e com semana.',
  },
  en: {
    'dashboard.aba.operacao': 'Operations',
    'dashboard.aba.planejamento': 'Planning',
    'dashboard.planejamento.titulo': 'Harvest forecast',
    'dashboard.planejamento.detalhe': 'The customer planning spreadsheet, one row per contract and farm, against the Protheus measurement.',
    'dashboard.planejamento.lidas': 'Protheus measurements read on {{quando}}',
    'dashboard.planejamento.semLeitura': 'No Protheus measurement read yet',
    'dashboard.planejamento.loadError': 'Unable to load the planning',
    'dashboard.planejamento.cliente': 'Customer',
    'dashboard.planejamento.importar': 'Import spreadsheet',
    'dashboard.planejamento.importarTitulo': 'Import the planning spreadsheet',
    'dashboard.planejamento.importarExplica': 'Send the customer planning spreadsheet as it comes, in .xlsx or .csv. It needs the Contract and Harvest Week columns, and a row without a week comes in anyway, out of the weekly figures. Hectares, Km, Volume, Operation, Farm, City, State, Grower and UBS come in when present, and an empty cell does not erase what was saved. The date becomes the Monday of its week, and the informed date is kept. The same contract on two farms becomes two rows. A contract not yet registered comes in anyway and links itself once registered.',
    'dashboard.planejamento.arquivo': 'Choose spreadsheet',
    'dashboard.planejamento.carga.gravadas': 'New',
    'dashboard.planejamento.carga.atualizadas': 'Updated',
    'dashboard.planejamento.carga.mantidas': 'Unchanged',
    'dashboard.planejamento.carga.ignoradas': 'Rows skipped',
    'dashboard.planejamento.carga.pendentes': 'Not registered in HUB',
    'dashboard.planejamento.carga.replanejadas': 'With a new week',
    'dashboard.planejamento.carga.primeiraSemana': 'First week',
    'dashboard.planejamento.carga.ultimaSemana': 'Last week',
    'dashboard.planejamento.carga.hectares': 'Planned hectares',
    'dashboard.planejamento.ind.contratos': 'Planned contracts',
    'dashboard.planejamento.ind.contratosHint': '{{n}} not registered in HUB',
    'dashboard.planejamento.ind.contratosTodos': 'all registered in HUB',
    'dashboard.planejamento.ind.previsto': 'Planned hectares',
    'dashboard.planejamento.ind.previstoHint': '{{n}} trips by the calculation below',
    'dashboard.planejamento.ind.medido': 'Measured hectares',
    'dashboard.planejamento.ind.medidoHint': '{{pct}} of plan in contracts already measured',
    'dashboard.planejamento.ind.medidoNada': 'no measurement yet',
    'dashboard.planejamento.ind.fora': 'Off the week',
    'dashboard.planejamento.ind.foraHint': '{{n}} without measurement after their week',
    'dashboard.planejamento.ind.pico': 'Truck peak',
    'dashboard.planejamento.ind.picoHint': 'week of {{semana}}',
    'dashboard.planejamento.ind.picoNada': 'no trip planned',
    'dashboard.planejamento.hectaresTitulo': 'Hectares per week',
    'dashboard.planejamento.hectaresRodape': 'Harvest contracts only. Planned by the week in the client spreadsheet, measured by the end date of the Protheus measurement.',
    'dashboard.planejamento.caminhoesTitulo': 'Trucks per week',
    'dashboard.planejamento.caminhoesRodape': 'Transport contracts only. Planned: one truck every {{ha}} hectares. Used: the loads that ran in the week, by HUB date.',
    'dashboard.planejamento.serie.previsto': 'Planned',
    'dashboard.planejamento.serie.medido': 'Measured',
    'dashboard.planejamento.semDados': 'No forecast in this selection',
    'dashboard.planejamento.parametros': 'Calculation settings',
    'dashboard.planejamento.parametrosExplica': 'The calculation updates at once and is kept only in this browser.',
    'dashboard.planejamento.param.haPorViagem': 'Hectares per trip',
    'dashboard.planejamento.param.haPorViagemAjuda': 'Default is 3. The real average of measured contracts was 3.33 on 10/27/2026.',
    'dashboard.planejamento.param.restaurar': 'Reset to default',
    'dashboard.planejamento.semKm_one': '{{count}} transport contract without km in the record is left out of the average km.',
    'dashboard.planejamento.semKm_other': '{{count}} transport contracts without km in the record are left out of the average km.',
    'dashboard.planejamento.semanas': 'Week by week',
    'dashboard.planejamento.col.semana': 'Week',
    'dashboard.planejamento.col.contratos': 'Contracts',
    'dashboard.planejamento.col.previsto': 'Planned',
    'dashboard.planejamento.col.medido': 'Measured',
    'dashboard.planejamento.col.viagens': 'Trips',
    'dashboard.planejamento.col.kmMedio': 'Average km',
    'dashboard.planejamento.col.contrato': 'Contract',
    'dashboard.planejamento.col.fazenda': 'Farm',
    'dashboard.planejamento.col.semanaPrevista': 'Planned week',
    'dashboard.planejamento.col.diferenca': 'Difference',
    'dashboard.planejamento.col.colheita': 'Actual date',
    'dashboard.planejamento.col.km': 'Km',
    'dashboard.planejamento.col.situacao': 'Status',
    'dashboard.planejamento.semanaAtual': 'This week',
    'dashboard.planejamento.antes': 'Was {{data}}',
    'dashboard.planejamento.doContrato': 'from contract',
    'dashboard.planejamento.semCadastro': 'Not registered',
    'dashboard.planejamento.periodo': '{{de}} to {{ate}}',
    'dashboard.planejamento.contratos': 'Planned contracts',
    'dashboard.planejamento.total_one': '{{count}} contract',
    'dashboard.planejamento.total_other': '{{count}} contracts',
    'dashboard.planejamento.vazio': 'No planning spreadsheet imported yet. Import the customer spreadsheet to start.',
    'dashboard.planejamento.vazioLeitura': 'No planning spreadsheet imported yet.',
    'dashboard.planejamento.situacao.no_prazo': 'On time',
    'dashboard.planejamento.situacao.adiantada': 'Early',
    'dashboard.planejamento.situacao.atrasada': 'Late',
    'dashboard.planejamento.situacao.sem_medicao': 'No measurement',
    'dashboard.planejamento.situacao.na_semana': 'This week',
    'dashboard.planejamento.situacao.prevista': 'Planned',
    'dashboard.planejamento.carga.semSemana': 'Without week',
    'dashboard.planejamento.ind.semSemana': '{{n}} without week',
    'dashboard.planejamento.situacao.so_transporte': 'Transport only',
    'dashboard.planejamento.situacao.sem_semana': 'No week',
    'dashboard.planejamento.semSemana': 'No week',
    'dashboard.planejamento.informada': 'Informed {{data}}',
    'dashboard.planejamento.col.operacao': 'Operation',
    'dashboard.planejamento.numeroRepetido': 'On more than one farm',
    'dashboard.planejamento.numeroRepetidoAjuda': 'The same number comes on more than one farm in the spreadsheet. The HUB contract links only to the row of the farm with its name.',
    'dashboard.planejamento.foraDaPlanilha_one': '{{count}} HUB contract still to harvest is not in the spreadsheet',
    'dashboard.planejamento.foraDaPlanilha_other': '{{count}} HUB contracts still to harvest are not in the spreadsheet',
    'dashboard.planejamento.foraDaPlanilhaVer': 'See contracts',
    'dashboard.planejamento.foraDaPlanilhaMais_one': 'and {{count}} more contract',
    'dashboard.planejamento.foraDaPlanilhaMais_other': 'and {{count}} more contracts',
    'dashboard.planejamento.remover': 'Remove forecast',
    'dashboard.planejamento.removerTitulo': 'Remove the forecast for contract {{numero}}?',
    'dashboard.planejamento.removerMensagem': 'It leaves the tab and the calculations. To bring it back, import the spreadsheet again.',
    'dashboard.planejamento.removerConfirmar': 'Remove',
    'dashboard.planejamento.removida': 'Forecast removed.',
    'dashboard.planejamento.serie.previstos': 'Planned',
    'dashboard.planejamento.serie.utilizados': 'Used',
    'dashboard.planejamento.col.caminhoesPrevistos': 'Planned trucks',
    'dashboard.planejamento.col.caminhoesUtilizados': 'Used trucks',
    'dashboard.planejamento.pelasViagens': 'by trips',
    'dashboard.planejamento.filtro.clienteHub': 'HUB client',
    'dashboard.planejamento.filtro.clienteProtheus': 'Protheus client',
    'dashboard.planejamento.filtro.dupla': 'Pair',
    'dashboard.planejamento.filtro.operacao': 'Operation',
    'dashboard.planejamento.filtro.limpar': 'Clear filters',
    'dashboard.planejamento.operacao.colheita': 'Harvest',
    'dashboard.planejamento.operacao.transporte': 'Transport',
    'dashboard.planejamento.operacao.colheita_transporte': 'Harvest and Transport',
    'dashboard.planejamento.clientes.titulo': 'Hectares by client',
    'dashboard.planejamento.clientes.col.cliente': 'Client',
    'dashboard.planejamento.clientes.col.lancados': 'Hectares entered',
    'dashboard.planejamento.clientes.col.colhidos': 'Hectares harvested',
    'dashboard.planejamento.clientes.col.pct': '%',
    'dashboard.planejamento.clientes.total': 'Total',
    'dashboard.planejamento.clientes.semCliente': 'No client',
    'dashboard.planejamento.clientes.rodape': 'Entered are the hectares planned in the spreadsheet, and harvested the ones measured by Protheus. Harvest contracts with a week only.',
  },
  es: {
    'dashboard.aba.operacao': 'Operación',
    'dashboard.aba.planejamento': 'Planificación',
    'dashboard.planejamento.titulo': 'Previsión de cosecha',
    'dashboard.planejamento.detalhe': 'La planilla de planificación del cliente, una fila por contrato y hacienda, frente a la medición del Protheus.',
    'dashboard.planejamento.lidas': 'Mediciones del Protheus leídas el {{quando}}',
    'dashboard.planejamento.semLeitura': 'Todavía no hay lectura de mediciones del Protheus',
    'dashboard.planejamento.loadError': 'No se pudo cargar la planificación',
    'dashboard.planejamento.cliente': 'Cliente',
    'dashboard.planejamento.importar': 'Importar planilla',
    'dashboard.planejamento.importarTitulo': 'Importar la planilla de planificación',
    'dashboard.planejamento.importarExplica': 'Envíe la planilla de planificación del cliente tal como llega, en .xlsx o .csv. Necesita las columnas Contrato y Semana Cosecha, y la fila sin semana entra igual, fuera de las cuentas por semana. Hectáreas, Km, Volumen, Operación, Hacienda, Ciudad, Estado, Cooperante y UBS entran cuando existen, y la celda vacía no borra lo grabado. La fecha pasa al lunes de su semana, y la fecha informada queda guardada. El mismo contrato en dos haciendas se vuelve dos filas. El contrato aún sin registro entra igual y se vincula solo cuando se registre.',
    'dashboard.planejamento.arquivo': 'Elegir planilla',
    'dashboard.planejamento.carga.gravadas': 'Nuevas',
    'dashboard.planejamento.carga.atualizadas': 'Actualizadas',
    'dashboard.planejamento.carga.mantidas': 'Sin cambios',
    'dashboard.planejamento.carga.ignoradas': 'Filas ignoradas',
    'dashboard.planejamento.carga.pendentes': 'Sin registro en el HUB',
    'dashboard.planejamento.carga.replanejadas': 'Con semana nueva',
    'dashboard.planejamento.carga.primeiraSemana': 'Primera semana',
    'dashboard.planejamento.carga.ultimaSemana': 'Última semana',
    'dashboard.planejamento.carga.hectares': 'Hectáreas previstas',
    'dashboard.planejamento.ind.contratos': 'Contratos previstos',
    'dashboard.planejamento.ind.contratosHint': '{{n}} sin registro en el HUB',
    'dashboard.planejamento.ind.contratosTodos': 'todos registrados en el HUB',
    'dashboard.planejamento.ind.previsto': 'Hectáreas previstas',
    'dashboard.planejamento.ind.previstoHint': '{{n}} viajes según el cálculo abajo',
    'dashboard.planejamento.ind.medido': 'Hectáreas medidas',
    'dashboard.planejamento.ind.medidoHint': '{{pct}} de lo previsto en los contratos ya medidos',
    'dashboard.planejamento.ind.medidoNada': 'todavía sin medición',
    'dashboard.planejamento.ind.fora': 'Fuera de la semana',
    'dashboard.planejamento.ind.foraHint': '{{n}} sin medición con la semana ya pasada',
    'dashboard.planejamento.ind.pico': 'Pico de camiones',
    'dashboard.planejamento.ind.picoHint': 'semana del {{semana}}',
    'dashboard.planejamento.ind.picoNada': 'sin viaje previsto',
    'dashboard.planejamento.hectaresTitulo': 'Hectáreas por semana',
    'dashboard.planejamento.hectaresRodape': 'Solo contratos con cosecha. Previsto por la semana de la planilla del cliente, medido por la fecha final de la medición de Protheus.',
    'dashboard.planejamento.caminhoesTitulo': 'Camiones por semana',
    'dashboard.planejamento.caminhoesRodape': 'Solo contratos con transporte. Previstos: un camión cada {{ha}} hectáreas. Utilizados: las cargas que corrieron en la semana, por la Fecha HUB.',
    'dashboard.planejamento.serie.previsto': 'Previsto',
    'dashboard.planejamento.serie.medido': 'Medido',
    'dashboard.planejamento.semDados': 'Sin previsión en la selección',
    'dashboard.planejamento.parametros': 'Parámetros del cálculo',
    'dashboard.planejamento.parametrosExplica': 'El cálculo cambia al instante y vale solo en este navegador.',
    'dashboard.planejamento.param.haPorViagem': 'Hectáreas por viaje',
    'dashboard.planejamento.param.haPorViagemAjuda': 'El estándar es 3. El promedio real de los contratos medidos fue 3,33 el 27/10/2026.',
    'dashboard.planejamento.param.restaurar': 'Volver al estándar',
    'dashboard.planejamento.semKm_one': '{{count}} contrato con transporte sin km en el registro queda fuera del km medio.',
    'dashboard.planejamento.semKm_other': '{{count}} contratos con transporte sin km en el registro quedan fuera del km medio.',
    'dashboard.planejamento.semanas': 'Semana a semana',
    'dashboard.planejamento.col.semana': 'Semana',
    'dashboard.planejamento.col.contratos': 'Contratos',
    'dashboard.planejamento.col.previsto': 'Previsto',
    'dashboard.planejamento.col.medido': 'Medido',
    'dashboard.planejamento.col.viagens': 'Viajes',
    'dashboard.planejamento.col.kmMedio': 'Km promedio',
    'dashboard.planejamento.col.contrato': 'Contrato',
    'dashboard.planejamento.col.fazenda': 'Hacienda',
    'dashboard.planejamento.col.semanaPrevista': 'Semana prevista',
    'dashboard.planejamento.col.diferenca': 'Diferencia',
    'dashboard.planejamento.col.colheita': 'Fecha real',
    'dashboard.planejamento.col.km': 'Km',
    'dashboard.planejamento.col.situacao': 'Situación',
    'dashboard.planejamento.semanaAtual': 'Semana actual',
    'dashboard.planejamento.antes': 'Antes {{data}}',
    'dashboard.planejamento.doContrato': 'del contrato',
    'dashboard.planejamento.semCadastro': 'Sin registro',
    'dashboard.planejamento.periodo': '{{de}} a {{ate}}',
    'dashboard.planejamento.contratos': 'Contratos previstos',
    'dashboard.planejamento.total_one': '{{count}} contrato',
    'dashboard.planejamento.total_other': '{{count}} contratos',
    'dashboard.planejamento.vazio': 'Todavía no se importó ninguna planilla de planificación. Importe la planilla del cliente para empezar.',
    'dashboard.planejamento.vazioLeitura': 'Todavía no se importó ninguna planilla de planificación.',
    'dashboard.planejamento.situacao.no_prazo': 'En plazo',
    'dashboard.planejamento.situacao.adiantada': 'Adelantada',
    'dashboard.planejamento.situacao.atrasada': 'Atrasada',
    'dashboard.planejamento.situacao.sem_medicao': 'Sin medición',
    'dashboard.planejamento.situacao.na_semana': 'En la semana',
    'dashboard.planejamento.situacao.prevista': 'Prevista',
    'dashboard.planejamento.carga.semSemana': 'Sin semana',
    'dashboard.planejamento.ind.semSemana': '{{n}} sin semana',
    'dashboard.planejamento.situacao.so_transporte': 'Solo transporte',
    'dashboard.planejamento.situacao.sem_semana': 'Sin semana',
    'dashboard.planejamento.semSemana': 'Sin semana',
    'dashboard.planejamento.informada': 'Informada {{data}}',
    'dashboard.planejamento.col.operacao': 'Operación',
    'dashboard.planejamento.numeroRepetido': 'En más de una hacienda',
    'dashboard.planejamento.numeroRepetidoAjuda': 'El mismo número viene en más de una hacienda en la planilla. El contrato del HUB se vincula solo a la fila de la hacienda con su nombre.',
    'dashboard.planejamento.foraDaPlanilha_one': '{{count}} contrato del HUB aún por cosechar no está en la planilla',
    'dashboard.planejamento.foraDaPlanilha_other': '{{count}} contratos del HUB aún por cosechar no están en la planilla',
    'dashboard.planejamento.foraDaPlanilhaVer': 'Ver contratos',
    'dashboard.planejamento.foraDaPlanilhaMais_one': 'y {{count}} contrato más',
    'dashboard.planejamento.foraDaPlanilhaMais_other': 'y {{count}} contratos más',
    'dashboard.planejamento.remover': 'Quitar previsión',
    'dashboard.planejamento.removerTitulo': '¿Quitar la previsión del contrato {{numero}}?',
    'dashboard.planejamento.removerMensagem': 'Sale de la pestaña y de los cálculos. Para volver, importe la planilla de nuevo.',
    'dashboard.planejamento.removerConfirmar': 'Quitar',
    'dashboard.planejamento.removida': 'Previsión quitada.',
    'dashboard.planejamento.serie.previstos': 'Previstos',
    'dashboard.planejamento.serie.utilizados': 'Utilizados',
    'dashboard.planejamento.col.caminhoesPrevistos': 'Camiones previstos',
    'dashboard.planejamento.col.caminhoesUtilizados': 'Camiones utilizados',
    'dashboard.planejamento.pelasViagens': 'por los viajes',
    'dashboard.planejamento.filtro.clienteHub': 'Cliente HUB',
    'dashboard.planejamento.filtro.clienteProtheus': 'Cliente Protheus',
    'dashboard.planejamento.filtro.dupla': 'Dupla',
    'dashboard.planejamento.filtro.operacao': 'Operación',
    'dashboard.planejamento.filtro.limpar': 'Limpiar filtros',
    'dashboard.planejamento.operacao.colheita': 'Cosecha',
    'dashboard.planejamento.operacao.transporte': 'Transporte',
    'dashboard.planejamento.operacao.colheita_transporte': 'Cosecha y Transporte',
    'dashboard.planejamento.clientes.titulo': 'Hectáreas por cliente',
    'dashboard.planejamento.clientes.col.cliente': 'Cliente',
    'dashboard.planejamento.clientes.col.lancados': 'Hectáreas cargadas',
    'dashboard.planejamento.clientes.col.colhidos': 'Hectáreas cosechadas',
    'dashboard.planejamento.clientes.col.pct': '%',
    'dashboard.planejamento.clientes.total': 'Total',
    'dashboard.planejamento.clientes.semCliente': 'Sin cliente',
    'dashboard.planejamento.clientes.rodape': 'Cargadas son las hectáreas previstas en la planilla, y cosechadas las medidas por Protheus. Solo contratos con cosecha y con semana.',
  },
}
